module.exports = __webpack_public_path__ + "img/logo-m2n.1f1532aa.svg";